import { CrewUi } from 'corso-types';
import { match } from 'ts-pattern';
import { settingsContext } from '~/app/settingsMiddleware';
import { isAppEmbedded } from '~/utils/appEmbed';
import { makeLoader, redirect } from '~/utils/routing';
import { registrationContext } from '../registrationMiddleware';

const getIncentiveHeadline = (isRedeemed: boolean, isExpired: boolean) =>
  match({ isRedeemed, isExpired })
    .with({ isRedeemed: true }, () => 'Discount redeemed')
    .with({ isExpired: true }, () => 'Discount expired')
    .otherwise(() => 'You earned a discount');

const formatDiscountIncentive = (
  discountIncentive: CrewUi.Registration['discountIncentive'],
) => {
  if (!discountIncentive) return null;

  const { code, message, expiresOn } = discountIncentive;

  const isRedeemed = !!discountIncentive.redeemedOn;
  const isExpired = !!expiresOn && new Date(expiresOn) < new Date();
  const isActive = !isRedeemed && !isExpired;

  return {
    headline: getIncentiveHeadline(isRedeemed, isExpired),
    code,
    message,
    isRedeemed,
    expiresOn,
    isExpired,
    // Only surface a Redeem URL while the discount is still usable — the
    // component renders the link unconditionally when this is non-null.
    redemptionUrl: isActive ? discountIncentive.redemptionUrl : null,
    isActive,
  };
};

export const { loader, useLoaderData } = makeLoader(({ context, params }) => {
  const {
    registrations: { isStartWarrantyClaimEnabled },
    storeUrl,
    theme,
  } = context.get(settingsContext);
  // the new registration created in the previous action
  const { registration, referrer } = context.get(registrationContext);

  if (!registration) return redirect(`/${params.store ?? ''}`);

  const { discountIncentive, ...regNoIncentive } = registration;

  return {
    formattedIncentive: formatDiscountIncentive(discountIncentive),
    registration: regNoIncentive,
    referrer,
    storeUrl,
    isStartWarrantyClaimEnabled,
    isEmbedded: isAppEmbedded(),
    registrationSubmissionText:
      theme.registrationSubmissionText ??
      'Thank you for your registration, please keep this number for your records.',
  };
});
